module.exports = __webpack_public_path__ + "static/media/platycleis_grisea_011_Tag_APA.135ea637.png";